// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"279":"6c44d60f","296":"ea88be26","714":"fec483df"}[chunkId] || chunkId) + "." + {"229":"e6d8ddb1cd6797fd","279":"e2720511c285403b","296":"1a112e62a60bad04","714":"672b6b40c614afb2","817":"5df4483ccc814a21","838":"98bd11b4af78d574"}[chunkId] + ".js";
};